module.exports = __webpack_public_path__ + "static/media/valise-sante.1bf7111a.svg";